import React, { useState } from 'react';
import type { FC } from 'react';
import { useIntl } from 'react-intl-next';

import FeedbackCollector, { FeedbackFlag } from '@atlaskit/feedback-collector';
import Button from '@atlaskit/button';
import { FlagGroup } from '@atlaskit/flag';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { i18n } from './AdvancedSearch-i18n.ts';

const ENTRYPOINT_ID = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
const FEEDBACK_CONTEXT_CF = 'customfield_10047';

export const ASFeedbackCollector: FC = () => {
	const { displayName, cloudId, userId, isAdminHubAIEnabled, locale } = useSessionData();
	const [isOpen, setIsOpen] = useState(false);
	const [displayFlag, setDisplayFlag] = useState(false);
	const intl = useIntl();

	const feedbackContext = `displayName: ${displayName}, userId: ${userId}, cloudId: ${cloudId}, locale: ${locale}, isAdminHubAIEnabled: ${!!isAdminHubAIEnabled}, source: Confluence Advanced Search, product: confluence, primaryProduct: confluence,`;

	return (
		<>
			<Button
				appearance="subtle"
				onClick={(e) => {
					e.preventDefault();
					setIsOpen(true);
				}}
			>
				{intl.formatMessage(i18n.feedbackButton)}
			</Button>
			{isOpen && (
				<FeedbackCollector
					locale={locale}
					onClose={() => setIsOpen(false)}
					onSubmit={() => {
						setDisplayFlag(true);
						setIsOpen(false);
					}}
					name={displayName || ''}
					entrypointId={ENTRYPOINT_ID}
					additionalFields={[
						{
							id: FEEDBACK_CONTEXT_CF,
							value: feedbackContext,
						},
					]}
				/>
			)}
			<FlagGroup onDismissed={() => setDisplayFlag(false)}>
				{displayFlag && <FeedbackFlag />}
			</FlagGroup>
		</>
	);
};
